import React from "react";
import styles from "./cv-new.module.scss";
import profilePic from "../../assets/profilepic.jpeg";

interface Job {
  title: string;
  period: string;
  company: string;
  location: string;
  points: string[];
}

const jobs: Job[] = [
  {
    title: "Fullstack Engineer",
    period: "Feb 2023 – Present",
    company: "Interhyp Gruppe",
    location: "München",
    points: [
      "Comparison portal for real estate trading",
      '"Home" as new portal in the future',
      "Cloud based network of ~100 microservices",
    ],
  },
  {
    title: "Fullstack Developer",
    period: "Jun 2021 – Dec 2022",
    company: "SprintEins GmbH",
    location: "München",
    points: [
      "Emission certification process tool for Mercedes-Benz",
      'Assisting from certification inquiry to .doc-export to the "KBA"',
      "Non-profit projects in cooperation with Caritas",
    ],
  },
  {
    title: "Software Developer",
    period: "Jun 2019 – Dec 2020",
    company: "Juconn GmbH",
    location: "Unterföhring",
    points: [
      "IoT sensor data processing and visualizing",
      "Automatic generated reports",
      "Microservices in NestJS / TypeScript",
    ],
  },
  {
    title: "Software Developer",
    period: "Mar 2019 – Jun 2019",
    company: "Wunderlabs UG",
    location: "Hallbergmoos",
    points: [
      "Responsive websites with mobile-first architecture",
      "Backends with Python-based CRMs",
    ],
  },
  {
    title: "Software Developer",
    period: "Jun 2018 – Feb 2019",
    company: "Artus Management GmbH",
    location: "Kulmbach",
    points: ["Automated arbitrage trading with crypto currencies"],
  },
];

const techStack = [
  "TypeScript",
  "JavaScript",
  "React",
  "Node.js",
  "NestJS",
  "Redux",
  "TypeORM",
  "Go",
  "Java",
  "Docker",
  "Kubernetes",
  "PostgreSQL",
  "MongoDB",
  "MySQL",
];

const softSkills = ["Inventiveness", "Ambitious", "Teamplayer", "Cooking"];
const certificates = ["French DELF A1", "Brandschutzhelfer (Oct 2022)"];

const CVNew: React.FC = () => {
  return (
    <div className={styles.page}>
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.photo}>
          <img src={profilePic} alt="Maximilian Grätz" />
        </div>
        <div className={styles.heroInfo}>
          <h1 className={styles.heroName}>Maximilian Grätz</h1>
          <p className={styles.heroSubtitle}>Fullstack Engineer</p>
          <div className={styles.heroContact}>
            <a href="mailto:max@mgraetz.de">max@mgraetz.de</a>
            <span>+49 178 5598780</span>
            <span>Mühldorf a. Inn, Bavaria</span>
          </div>
        </div>
      </section>

      {/* Experience */}
      <section>
        <h2 className={styles.sectionTitle}>Professional Experience</h2>
        <div className={styles.cardGrid}>
          {jobs.map((job, i) => (
            <article className={styles.card} key={i}>
              <h3 className={styles.cardTitle}>{job.title}</h3>
              <div className={styles.cardMeta}>{job.period}</div>
              <div className={styles.cardCompany}>
                {job.company}, {job.location}
              </div>
              <ul className={styles.cardPoints}>
                {job.points.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      {/* Bottom row */}
      <div className={styles.bottomRow}>
        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Tech Stack</h2>
          <div className={styles.tags}>
            {techStack.map((t) => (
              <span className={styles.tag} key={t}>
                {t}
              </span>
            ))}
          </div>
        </section>

        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Education</h2>
          <h3 className={styles.eduSchool}>FH Rosenheim</h3>
          <div className={styles.eduPeriod}>Oct 2014 – Jun 2018</div>
          <ul className={styles.plainList}>
            <li>3 Semester "Wirtschaftsinformatik"</li>
            <li>4 Semester "Informatik"</li>
          </ul>
        </section>

        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Certificates</h2>
          <ul className={styles.plainList}>
            {certificates.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>

          <h2 className={styles.sectionTitle} style={{ marginTop: 20 }}>
            Soft Skills
          </h2>
          <ul className={styles.plainList}>
            {softSkills.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default CVNew;
